import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const parser = {
  parseProductCard: lazyModuleMethod(
    () => import('./parseProductCard'),
    'default'
  ),
  parseSocialImage: lazyModuleMethod(
    () => import('./parseSocialImage'),
    'default'
  ),
}
